import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import { FormattedMessage, useIntl } from "react-intl";
import { ApplicationForm, ApplicantRoleUnavailable } from "components/Missions/Applicants";
import PageTitle from "components/PageTitle";
import { PageWrapper } from "components/Containers";
import { useAuth, useLinks, useMissionRoleApplicant } from "hooks";
import { PrimaryLink } from "components/Links";

/**
 * MissionApplications
 */
const MissionApplications = () => {
  const intl = useIntl();
  const { id } = useParams();
  const { isFreelancer } = useAuth();
  const { data, loading } = useMissionRoleApplicant({ id });
  const links = useLinks();
  const [rateEditing, setRateEditing] = useState(false);
  const [questionnaireEditing, setQuestionnaireEditing] = useState(false);
  const [requirementsEditing, setRequirementsEditing] = useState(false);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    setSelected(data);
  }, [data]);

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Missions.Applications.Title" })}</title>
      </Helmet>
      <PageWrapper>
        {selected && (
          <PageTitle
            title={
              <FormattedMessage id={"MissionApplications.PageTitle"} values={{ role: selected?.missionRole?.name }} />
            }
            backLink={
              isFreelancer && (
                <PrimaryLink to={links.mission_applications} routerEnabled>
                  <FormattedMessage id="MissionApplicatons.PageTitle.BackLink.Text" />
                </PrimaryLink>
              )
            }
          />
        )}
        <ApplicantRoleUnavailable application={selected} isMember />
        <ApplicationForm
          selected={selected}
          loading={loading}
          rateEditing={rateEditing}
          setRateEditing={setRateEditing}
          questionnaireEditing={questionnaireEditing}
          setQuestionnaireEditing={setQuestionnaireEditing}
          requirementsEditing={requirementsEditing}
          setRequirementsEditing={setRequirementsEditing}
          hideContactUs={false}
        />
      </PageWrapper>
    </>
  );
};

export default MissionApplications;
